module.exports = [
  {
    url: '/news/aihunters-becomes-member-of-google-for-startups-cloud-program/',
    img: '/uploads/resources/news/aihunters-becomes-member-of-google-for-startups-cloud-program/1.jpg',
    date: 'Jul 19, 2023',
    title:
      'AIHunters becomes a member of Google for Startups Cloud Program to power R&D',
    readTime: 1,
  },
  {
    url: '/news/aihunters-brings-subtitling-automation-for-lovetv/',
    img: '/uploads/resources/news/aihunters-brings-subtitling-automation-for-lovetv/1.jpg',
    date: 'Jun 7, 2023',
    title:
      'AIHunters brings Cognitive AI to subtitling automation for LoveTV',
    readTime: 2,
  },
  {
    url: '/news/aihunters-and-grid-streamline-esports-streaming/',
    img: '/uploads/resources/news/aihunters-and-grid-streamline-esports-streaming/1.jpg',
    date: 'May 15, 2023',
    title:
      'AIHunters streamlines e-sports streaming with cognitive AI automation',
    readTime: 1,
  },
  {
    url: '/news/aihunters-helps-bravo-studio/',
    img: '/uploads/resources/news/aihunters-helps-bravo-studio/1.jpg',
    date: 'Apr 21, 2023',
    title:
      'AIHunters helps BRAVÒ optimize the video production efficiency',
    readTime: 2,
  },
  {
    url: '/news/aihunters-new-approach-to-trailers/',
    img: '/uploads/resources/news/aihunters-new-approach-to-trailers/1.jpg',
    date: 'Feb 21, 2023',
    title:
      'AIHunters tried their hand at a fresh approach to automated trailer-generation',
    readTime: 3,
  },
  {
    url: '/news/aihunters-partners-melbourne-university/',
    img: '/uploads/resources/news/aihunters-partners-melbourne-university/1.jpg',
    date: 'Feb 14, 2023',
    title:
      'AIHunters helps University of Melbourne research auction attendance',
    readTime: 3,
  },
  {
    url: '/news/aihunters-partners-oxagile/',
    img: '/uploads/resources/news/aihunters-partners-oxagile/1.png',
    date: 'Aug 31, 2022',
    title: 'AIHunters Partners with Oxagile to Revamp Consumer-Driven OTT',
    readTime: 2,
  },
  {
    url: '/news/ibc-2022-demo/',
    img: '/uploads/resources/news/ibc-2022-demo/1.jpg',
    date: 'Aug 24, 2022',
    title: 'We are giving a demo at IBC 2022 on M&E robotization. Come see it!',
    readTime: 2,
  },
  {
    url: '/news/nagra-and-aihunters-partner/',
    img: '/uploads/resources/news/nagra-and-aihunters-partner/1.jpg',
    date: 'Aug 17, 2022',
    title: 'NAGRA and AIHunters partner for automated ad insertion',
    readTime: 2,
  },
  {
    url: '/news/ibc-2022/',
    img: '/uploads/resources/news/ibc-2022/1.png',
    date: 'Aug 10, 2022',
    title: 'Experience a new era of cognitive automation at IBC 2022!',
    readTime: 2,
  },
  {
    url: '/news/aihunters-becomes-nvidia-inception-partner/',
    img: '/uploads/resources/news/aihunters-becomes-nvidia-inception-partner/1.jpg',
    date: 'Jun 10, 2022',
    title: 'AIHunters becomes an official NVIDIA Inception partner',
    readTime: 2,
  },
  {
    url: '/news/aihunters-delivers-smooth-viewing-experiences-for-2-mln-end-users/',
    img: '/uploads/resources/news/aihunters-delivers-smooth-viewing-experiences-for-2-mln-end-users/1.jpg',
    date: 'Apr 06, 2022',
    title:
      'AIHunters delivers the intelligent end credits detection solution to power up Oxagile!',
    readTime: 3,
  },
  {
    url: '/news/aihunters-finds-a-strategic-partner/',
    img: '/uploads/resources/news/aihunters-finds-a-strategic-partner/1.jpg',
    date: 'Mar 25, 2022',
    title:
      'AIHunters finds a strategic partner in DDG AG for the expansion to the European market',
    readTime: 2,
  },
  {
    url: '/news/aihunters-and-tedial-announce-integration-partnership/',
    img: '/uploads/resources/news/aihunters-and-tedial-announce-integration-partnership/1.jpg',
    date: 'Mar 16, 2022',
    title: 'AIHunters and Tedial announce integration partnership',
    readTime: 3,
  },
  {
    url: '/news/aihunters-picked-for-demonstration-on-ibc-2021/',
    img: '/uploads/resources/news/aihunters-picked-for-demonstration-on-ibc-2021/1.png',
    date: 'Nov 18, 2021',
    title:
      'AIHunters is picked for a product demonstration on the IBC 2021 stage!',
    readTime: 2,
  },
];
